import { render, staticRenderFns } from "./UploadVideos.vue?vue&type=template&id=04e1d0d6&"
import script from "./UploadVideos.vue?vue&type=script&lang=js&"
export * from "./UploadVideos.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports